/** Scroll top aktuális értéke. */
export default function getScrollTop (): number {
  const scrollTop = (

    window.pageYOffset ||
    window.scrollY ||
    document.documentElement.scrollTop
  ) ?? 0

  return scrollTop
}
